// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-fwwgl-xxfb-index-main_right_content-3OD6E","table":"components-fwwgl-xxfb-index-table-1xhU6","button":"components-fwwgl-xxfb-index-button-3WnUA"};


//////////////////
// WEBPACK FOOTER
// ./components/fwwgl/xxfb/index.css
// module id = 2289
// module chunks = 0